import { TRANSFER_UPLOAD_V2 } from '@/utils/constants';
import { Box, Image, Spinner, Text } from '@chakra-ui/react';
import React from 'react'

export default function DocumentValidationInstruction({ isReviewPending = false, isManualReviewRequested = false }: any) {
  return (
    <Box className="upload-instructions document-validation">
      {(isManualReviewRequested || isReviewPending) ? (
        <Box className="instruction-box">
          <Box className="instr-img-box" sx={{ width: '80px !important' }}>
            <Image src="/images/ui/alert-yellow.svg" width={'40px'} height={'40px'} className="alert" />
          </Box>
          <Box className="instr-info">
            <Text className="instr-title" color={'#C58E53 !important'} sx={{ fontWeight: '700 !important' }}>
              {TRANSFER_UPLOAD_V2.SUBMITTED_FOR_REVIEW}
            </Text>
            <Text className="instr-desc">
              {TRANSFER_UPLOAD_V2.SUBMITTED_REVIEW_DESC}
            </Text>
          </Box>
        </Box>
      ) : (
        <Box>
          <Box className="instruction-box">
            <Box className="instr-img-box">
              <Image src="/images/ui/validationFileIcon.png" className="instImg" />
            </Box>
            <Box className="instr-info">
              <Text className="instr-title">
                {TRANSFER_UPLOAD_V2.DOCUMENT_VALIDATION_INSTR_TITLE}
              </Text>
              <Text className="instr-desc">
                {TRANSFER_UPLOAD_V2.DOCUMENT_VALIDATION_INSTR_DESC}
              </Text>
            </Box>
          </Box>
          <Box className="upload_file_progress_wrapper">
            <Spinner
              thickness={'4px'}
              speed="0.65s"
              emptyColor={'gray.200'}
              color="#0C1E46"
              size={'xl'}
            />
            <Text>Do not refresh or close the browser while validation is in progress...</Text>
          </Box>
        </Box>
      )}
    </Box>
  );
}